export default __webpack_public_path__ + "static/media/pillowCover.732eca15.svg";